/* import __COLOCATED_TEMPLATE__ from './predicate-editor.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import Component from '@ember/component';
import { equal, and, or } from '@ember/object/computed';
import { computed } from '@ember/object';
import { notImplemented, ternaryToProperty } from '@intercom/pulse/lib/computed-properties';
export default Component.extend({
  attributeBindings: ['data-test-predicate-editor'],
  mode: 'default',
  isOneLine: false,
  appearance: null,
  index: notImplemented('predicates/predicate-editor: You need to pass an index to this component'),
  predicate: notImplemented('predicates/predicate-editor: You need to pass a predicate to this component'),
  comparisonOptions: computed('mode', 'predicate', function () {
    return this.predicate.getComparisonOptions({
      mode: this.mode
    });
  }),
  hasSingleComparisonOption: equal('comparisonOptions.length', 1),
  predicateHasNoEditor: and('hasSingleComparisonOption', 'predicate.isNotValueBasedComparison'),
  _isLegacyGoalMode: equal('mode', 'goal'),
  _isStatSystemGoalMode: equal('mode', 'stat-system-goal'),
  _isEitherGoalMode: or('_isLegacyGoalMode', '_isStatSystemGoalMode'),
  predicateName: ternaryToProperty('_isEitherGoalMode', 'predicate.goalName', 'predicate.name'),
  predicateDescription: ternaryToProperty('_isEitherGoalMode', 'predicate.goalDescription.shortText', 'predicate.description')
});